import { render, staticRenderFns } from "./SourceBranch.vue?vue&type=template&id=7fa75530"
import script from "./SourceBranch.vue?vue&type=script&lang=js"
export * from "./SourceBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports